import {
    GET_CONTEST_HOME_PAGE_DATA, GET_CONTEST_HOME_PAGE_DATA_SUCCESS, GET_FEATURE_VIDEO, GET_FEATURE_VIDEO_SUCCESS, GET_CONTEST_DATA,
    GET_CONTEST_DATA_SUCCESS, GET_COUNTRY_WISE_CONTEST_DATA, GET_COUNTRY_WISE_CONTEST_DATA_SUCCESS, 
    GET_HOME_DATA_SUCCESS,
    GET_HOME_DATA,
    GET_MY_ACTIVITY,
    GET_MY_ACTIVITY_SUCCESS,
    GET_MONTHLY_ACTIVE_VOTERS,
    GET_MONTHLY_ACTIVE_VOTERS_SUCCESS,
    SET_MY_ACTIVITY_LOADER,
    UPDATE_MEDIA_VIEW_COUNT_FEATURED_VIDEOS_SUCCESS,
    HOME_ERROR
} from "../constants/actionTypes";

export const getHomeData = payload => ({
    type: GET_HOME_DATA,
    payload
});

export const getHomeDataSuccess = payload => ({
    type: GET_HOME_DATA_SUCCESS,
    payload
});

export const getContestHomeData = () => ({
    type: GET_CONTEST_HOME_PAGE_DATA
});

export const getContestHomeDataSuccess = payload => ({
    type: GET_CONTEST_HOME_PAGE_DATA_SUCCESS,
    payload
});

export const getFeaturedVideo = (payload) => ({
    type: GET_FEATURE_VIDEO,
    payload
});

export const getFeaturedVideoSuccess = payload => ({
    type: GET_FEATURE_VIDEO_SUCCESS,
    payload
});

export const getContestData = () => ({
    type: GET_CONTEST_DATA
});

export const getContestDataSuccess = payload => ({
    type: GET_CONTEST_DATA_SUCCESS,
    payload
});

export const getCountryWiseContestData = (payload) => ({
    type: GET_COUNTRY_WISE_CONTEST_DATA,
    payload
});

export const getCountryWiseContestDataSuccess = payload => ({
    type: GET_COUNTRY_WISE_CONTEST_DATA_SUCCESS,
    payload
});

export const getMyActivity = payload => ({
    type: GET_MY_ACTIVITY,
    payload
});

export const getMyActivitySuccess = payload => ({
    type: GET_MY_ACTIVITY_SUCCESS,
    payload
});
export const setMyActivityLoader = () => ({
    type: SET_MY_ACTIVITY_LOADER
});
export const getMonthlyActiveVoters = () => ({
    type: GET_MONTHLY_ACTIVE_VOTERS
});

export const getMonthlyActiveVotersSuccess = payload => ({
    type: GET_MONTHLY_ACTIVE_VOTERS_SUCCESS,
    payload
});

export const updateMediaViewCountFeaturedVideoSuccess = payload => ({
    type: UPDATE_MEDIA_VIEW_COUNT_FEATURED_VIDEOS_SUCCESS,
    payload
});

export const homeerror = () => ({
    type: HOME_ERROR
})